import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';
import * as toastr from 'toastr';
declare var Savane: any;
declare var AssetManagerServices: any;
export class GroupsFilterWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'groups';
        this.name = 'Groupes';
        this.icon = 'fas fa-lg fa-cubes';
        this.resource = 'assets_groups';
        this.showUnavailable = true;
        this.public_groups = true;
        this.filtersFunction = 'updateAssetsGroupsLists';
        this.container = container;
        this.controller = new FiltersController();
    }

    static newAssetsGroupsList() {
        Savane.eventsManager.instance.dispatch(Savane.Events.NEW_ASSETS_GROUPS_LIST);
    };

    static clearAssetsGroupsFilter() {
        FilterGroup.filters.assets = null;
        FilterGroup.updateFilters(FilterGroup.filters);
    }

    static selectAssetsGroups(item) {
        FilterGroup.selectedGroupdId = item._id;
        FilterGroup.filters.assets = item.items;
        FilterGroup.updateFilters(FilterGroup.filters);
    }

    static editAssetsGroupsList(item) {
        Savane.eventsManager.instance.dispatch(Savane.Events.EDIT_ASSETS_GROUPS_LIST, { assetsGroupsList: item });
    };

    static deleteAssetsGroupsList(item) {
        bootbox.dialog({
            className: "confirm",
            message: "Êtes-vous sûr de vouloir supprimer cette liste de groupes ?",
            buttons: {
                success: {
                    label: 'Oui',
                    className: "btn btn-link ",
                    callback: function () {
                        AssetManagerServices.deleteAssetsGroupsList(item._id, function (result) {
                            if (result) {
                                toastr.success('Liste de groupes supprimée avec succès.');
                                Savane.eventsManager.instance.dispatch(Savane.Events.REFRESH_ASSETS_GROUPS_LIST);
                            } else {
                                toastr.error('Une erreur est survenue lors de la suppression de la liste de groupes.');
                            }
                            setTimeout(function () {
                                FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                                Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                            });
                        });
                    }
                },
                danger: {
                    label: 'Non',
                    className: "btn btn-link btn-yes",
                    callback: function () { }
                }
            }
        });
    }

    html(): void {
        this.isDestroyed = false;
        FilterGroup.changeAssetsGroupsPage(FilterGroup.currentPage).then(() => {
            let html = this.filtersHtml() + `
            <div style="min-height: 200px;display: flex;flex-direction: column;">
                ${FiltersWidget.user.mail && FiltersWidget.getDecorationService().isUserAllowedToManageAssetsGroupsList ? `
                <div style="text-align: right; margin-right: 10px;">
                    <button id="NouvelleListeDeGroupes" class="btn btn-success">Nouvelle liste de groupes</button>
                </div>
                `: ''}
                <button id="AfficherTousLesGroupes" class="btn btn-default" style="background: transparent !important">Afficher tous les groupes</button>
                ${this.getGroupsTableHtml()}
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;

            setTimeout(() => {
                if (FiltersWidget.user.mail && FiltersWidget.getDecorationService().isUserAllowedToManageAssetsGroupsList) {
                    this.controller.addEventListener('click', () => {
                        GroupsFilterWidget.newAssetsGroupsList();
                    }, 'NouvelleListeDeGroupes');
                }

                this.controller.addEventListener('click', () => {
                    GroupsFilterWidget.clearAssetsGroupsFilter();
                }, 'AfficherTousLesGroupes');
            }, 50);
        });
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }

        if (filters.name) {
            stringFilters += '&q.name.lk=' + filters.name;
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        sort.push('name');

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };

    updateGroupsTableHtml(): void {
        const tbody = document.getElementById('group-tbody');
        if (tbody) {
            GroupsFilterWidget.assets_groups.forEach((item) => {
                this.controller.removeEventListener('click', `group-${item._id}`);
                this.controller.removeEventListener('click', `group-${item._id}-edit`);
                this.controller.removeEventListener('click', `group-${item._id}-delete`);
            });
            tbody.innerHTML = this.getGroupsHtml();
        }
    }

    getGroupsTableHtml(): string {
        if (!FilterGroup.assets_groups) return '';
        return `
        ${FilterGroup.assets_groups.length > 0 ? `
        <div style="margin-bottom:10px; margin-top: 10px; padding:0;width:100%; border-top: #737373 solid 1px;">
            <div>
                <table  class="table table-striped">
                    <thead>
                        <tr>
                            <th style="text-align: center;">Liste de groupe d'assets</th>
                        </tr>
                    </thead>
                    <tbody id="group-tbody">
                        ${this.getGroupsHtml()}
                    </tbody>
                </table>
            </div>
            ${this.getGroupsPaginationHtml()}
        </div>
        ` : ''}
        `;
    }

    getGroupsHtml(): string {
        return FilterGroup.assets_groups.map((item) => {
            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    GroupsFilterWidget.selectAssetsGroups(item);
                    this.updateGroupsTableHtml();
                }, `group-${item._id}`);

                if (FiltersWidget.getDecorationService().isUserAllowedToManageAssetsGroupsList) {
                    this.controller.addEventListener('click', () => {
                        GroupsFilterWidget.editAssetsGroupsList(item);
                    }, `group-${item._id}-edit`);

                    this.controller.addEventListener('click', () => {
                        GroupsFilterWidget.deleteAssetsGroupsList(item);
                        this.updateGroupsTableHtml();
                    }, `group-${item._id}-delete`);
                }
            }, 50);
            return `
            <tr style="cursor: pointer;">
                <td style="${FilterGroup.isGroupSelected(item)};"class="select-group" id="group-${item._id}">${item.name}</td>
                ${FiltersWidget.getDecorationService().isUserAllowedToManageAssetsGroupsList ? `
                <td>
                    <i id="group-${item._id}-edit" style="cursor: pointer;" class="fas fa-lg fa-edit"></i>
                    <i id="group-${item._id}-delete" style="cursor: pointer;" class="far fa-lg fa-trash-alt"></i>
                </td>
                ` : ''}
            </tr>
            `;
        }).join('');
    }

    getGroupsPaginationHtml(): string {
        setTimeout(() => {
            if (FilterGroup.pagination.currentPage !== 1) {
                this.controller.addEventListeners('click', (e) => {
                    e.preventDefault();
                    const element = e.target as HTMLElement;
                    const page = parseInt(element.getAttribute('data-page')!);
                    if (!isNaN(page) && page !== FilterGroup.pagination.currentPage && !element.classList.contains('disabled')) {
                        FilterGroup.changeAssetsGroupsPage(page).then(() => {
                            this.destroy();
                            this.html();
                        });
                    }
                }, 'pagination-number');
            }

            this.controller.addEventListener('click', (e) => {
                e.preventDefault();
                if (FilterGroup.pagination.currentPage > 1) {
                    FilterGroup.changeAssetsGroupsPage(FilterGroup.pagination.currentPage - 1).then(() => {
                        this.destroy();
                        this.html();
                    });
                }
            }, 'previous');

            this.controller.addEventListener('click', (e) => {
                e.preventDefault();
                if (FilterGroup.pagination.currentPage < FilterGroup.pagination.nbPages) {
                    FilterGroup.changeAssetsGroupsPage(FilterGroup.pagination.currentPage + 1).then(() => {
                        this.destroy();
                        this.html();
                    });
                }
            }, 'next');
        }, 50);
        return `
        <!-- PAGINATION -->
        <div style="background:none;height:24px;background-color : #efefef">
            <ul class="designer-filters pagination">
                <li class="${FilterGroup.pagination.currentPage === 1 ? 'disabled' : ''}">
                    <a id="previous" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>

                ${FilterGroup.pagination.currentPage > 1 ? `
                <li>
                    <a class="pagination-number" data-page="1">${FilterGroup.pagination.list[0].index}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 2 ? `
                <li>
                    <a class="pagination-number" data-page="2">${FilterGroup.pagination.list[1].index}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 5 ? `
                <li>
                    <span>...</span>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 4 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage - 2}">${FilterGroup.pagination.currentPage - 2}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 3 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage - 1}">${FilterGroup.pagination.currentPage - 1}</a>
                </li>
                ` : ''}

                <li class="active">
                    <span>${FilterGroup.pagination.currentPage}</span>
                </li>

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 2 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage + 1}">${FilterGroup.pagination.currentPage + 1}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 3 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage + 2}">${FilterGroup.pagination.currentPage + 2}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 4 ? `
                <li>
                    <span>...</span>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 1 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.pagination.list.length - 1}">
                        ${FilterGroup.pagination.list.length - 1}
                    </a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.pagination.list.length}">
                        ${FilterGroup.pagination.list.length}
                    </a>
                </li>
                ` : ''}
                
                <li class="${FilterGroup.pagination.currentPage === FilterGroup.pagination.nbPages ? 'disabled' : ''}">
                    <a id="next" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </div>
        `;
    }

    destroy(): void {
        super.destroy();
    }
}